export default class APIApplicationItem {
  constructor(API) {
    this.api = API;
  }

  async create(userID, certProcID, applicationType, sourceID, body) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/user/${userID}/certification/${certProcID}/application/${applicationType}/item/${sourceID}`;
    req.body = body;
    return await req.exec();
  }

  async addToBlacklist(userID, certProcID, applicationType, sourceID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = `/user/${userID}/certification/${certProcID}/application/${applicationType}/blacklist/${sourceID}`;
    return await req.exec();
  }

  async delete(userID, certProcID, applicationType, sourceID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = `/user/${userID}/certification/${certProcID}/application/${applicationType}/item/${sourceID}`;
    return await req.exec();
  }
}
